import React from "react";
import HeroPremium from "../components/HeroPremium";
import PositioningStatement from "../components/PositioningStatement";
import CapabilitiesSection from "../components/CapabilitiesSection";
import KeySectors from "../components/KeySectors";
import StrengthBlocks from "../components/StrengthBlocks";
import EvolutionSection from "../components/EvolutionSection";
import EcosystemSection from "../components/EcosystemSection";
import ImpactSection from "../components/ImpactSection";
import InsightsSection from "../components/InsightsSection";
import VideoProof from "../components/VideoProof";
import ConnectCTA from "../components/ConnectCTA";

const Home = () => {
  return (
    <>
      <HeroPremium />
      <PositioningStatement />
      <CapabilitiesSection />
      <EvolutionSection />
      <EcosystemSection />
      <KeySectors />
      <StrengthBlocks />
      <ImpactSection />
      <VideoProof />
      <InsightsSection />
      <ConnectCTA />
    </>
  );
};

export default Home;
